import { Box, Flex, HStack, Text, Button, Heading, Container, LightMode, Link as ChakraLink } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import MarketingFooter from './MarketingFooter';

const navLinks = [
  { label: 'Features', to: '/#features' },
  { label: 'Pricing', to: '/#pricing' },
  { label: 'Docs', to: '/docs' },
];

export const MarketingLayout = ({ title, subtitle, children, maxW = '900px' }) => (
  <LightMode>
  <Box bg="white" minH="100vh">
    {/* Navigation */}
    <Box as="nav" position="fixed" top={0} left={0} right={0} zIndex={1000} bg="whiteAlpha.900" backdropFilter="blur(10px)" borderBottom="1px solid" borderColor="gray.100" px={{ base: 4, md: 8 }} py={4}>
      <Flex maxW="1200px" mx="auto" justify="space-between" align="center">
        <ChakraLink as={RouterLink} to="/" _hover={{ textDecoration: 'none' }}>
          <HStack spacing={3}>
            <Box as="img" src="/falcon.svg" h="40px" />
            <Text fontFamily="logo" fontWeight="800" fontSize="xl" bgGradient="linear(to-r, brand.500, accent.500)" bgClip="text">StatFalcon</Text>
          </HStack>
        </ChakraLink>
        <HStack spacing={{ base: 3, md: 6 }}>
          <HStack spacing={6} display={{ base: 'none', md: 'flex' }}>
            {navLinks.map((link) => (
              <ChakraLink key={link.to} as={RouterLink} to={link.to} color="gray.600" fontWeight="500" _hover={{ color: 'brand.500' }}>{link.label}</ChakraLink>
            ))}
          </HStack>
          <Button as={RouterLink} to="/login" variant="outline" borderRadius="xl" borderColor="brand.500" color="brand.600" size="sm">Login</Button>
          <Button as={RouterLink} to="/" colorScheme="brand" borderRadius="xl" size="sm">Start Free</Button>
        </HStack>
      </Flex>
    </Box>

    {/* Page header */}
    {title && (
      <Box pt={{ base: 28, md: 32 }} pb={12} px={8} bgGradient="linear(to-b, brand.50, white)">
        <Container maxW={maxW}>
          <Heading as="h1" size={{ base: 'xl', md: '2xl' }} color="gray.900" mb={subtitle ? 4 : 0}>{title}</Heading>
          {subtitle && <Text fontSize={{ base: 'md', md: 'lg' }} color="gray.600">{subtitle}</Text>}
        </Container>
      </Box>
    )}

    {/* Content */}
    <Box as="main" pt={title ? 0 : { base: 28, md: 32 }} pb={20} px={8}>
      <Container maxW={maxW}>{children}</Container>
    </Box>

    <MarketingFooter />
  </Box>
  </LightMode>
);

export default MarketingLayout;
